import React, { type ElementType } from 'react';

import classnames from 'classnames';

import { ActionMenu } from '../../../ActionMenu';
import { Overflow } from '../../../Overflow/Overflow';
import { useBreadcrumbContext, type BreadcrumbItem } from '../../Breadcrumb.context';

import styles from './BreadcrumbRest.module.scss';

export type BreadcrumbRestProps = {
    as?: ElementType;
    className?: string;
    onItemClick?: (id: string) => void;
};

export const BreadcrumbRest = ({
    className,
    as = 'li',
    onItemClick,
    ...rest
}: BreadcrumbRestProps) => {
    const { hiddenItems } = useBreadcrumbContext();

    const handleClick =
        (id: string, onClick?: BreadcrumbItem['onClick']) =>
        (event: React.MouseEvent<HTMLButtonElement>) => {
            (onClick as React.MouseEventHandler<HTMLButtonElement>)?.(event);

            if (onItemClick) {
                event.preventDefault();
                onItemClick(id);
            }
        };

    return (
        <Overflow.Rest as={as} className={classnames(styles.container, className)} {...rest}>
            <ActionMenu
                actions={hiddenItems.map(({ id, onClick, ...restItem }) => ({
                    key: id,
                    id: String(id),
                    color: 'neutral' as const,
                    onClick: handleClick(id, onClick),
                    ...restItem
                }))}
                slotProps={{
                    tooltip: { hidden: true },
                    trigger: {
                        'aria-label': 'Show more',
                        type: 'ghost',
                        color: 'neutral',
                        tabIndex: hiddenItems.length === 0 ? -1 : 0
                    },
                    triggerIcon: {
                        size: 'medium',
                        name: 's-icon-ellipsis-horizontal',
                        'aria-hidden': true
                    }
                }}
            />
        </Overflow.Rest>
    );
};
